module.exports = __webpack_public_path__ + "img/cake.5d5a884b.svg";